import { render, staticRenderFns } from "./BannersWelcome.vue?vue&type=template&id=3cd12d02&scoped=true&"
import script from "./BannersWelcome.vue?vue&type=script&lang=js&"
export * from "./BannersWelcome.vue?vue&type=script&lang=js&"
import style0 from "./BannersWelcome.vue?vue&type=style&index=0&id=3cd12d02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd12d02",
  null
  
)

component.options.__file = "BannersWelcome.vue"
export default component.exports